module.exports = __webpack_public_path__ + "img/emoji-think.69a748fc.png";